import { useTranslation } from 'react-i18next';
import { mainSiteUrl, heroImage } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="USFANS spreadsheet fashion products flat lay"
          title="USFANS Spreadsheet — fashion product resource"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative mx-auto flex min-h-[620px] w-full max-w-5xl flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <span className="rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-background-50 backdrop-blur">
          {t('hero.eyebrow')}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          {t('hero.title')}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full rounded-md bg-accent-500 px-7 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto whitespace-nowrap"
          >
            {t('hero.ctaPrimary')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full rounded-md bg-background-50 px-7 py-3 text-base font-semibold text-foreground-950 transition-colors hover:bg-background-100 sm:w-auto whitespace-nowrap"
          >
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <p className="mt-6 text-xs text-background-100/80 md:text-sm">{t('hero.trust')}</p>
      </div>
    </section>
  );
}